<template lang="pug" src="./index.pug"></template>
<style lang="scss" src="./index.scss" scoped></style>

<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import validate from '@/mixins/validate'
import { email } from 'vuelidate/lib/validators'

export default {
    mixins: [validate, validationMixin],
    data: () => ({
        accountInfo: {
            firstName: null,
            lastName: null,
            email: null,
            phoneNumber: null,
            birthday: null
        },
        canSaveChanges: false
    }),
    validations: {
        accountInfo: {
            email: { email },
            firstName: {},
            lastName: {},
            birthday: {},
            phoneNumber: {}
        }
    },
    computed: {
        ...mapState({
            activeCustomer: state => state.customers.activeCustomer
        })
    },
    watch: {
        accountInfo: {
            handler() {
                this.canSaveChanges = true
            },
            deep: true
        }
    },
    created() {
        if (this.$route.params.id) {
            this.loadData()
        }
    },
    methods: {
        async loadData() {
            const customerId = this.$route.params.id
            await this.$store.dispatch('customers/getCustomerById', customerId).then(data => {
                this.accountInfo = Object.assign({},
                    Object.select(data, ['id', ...Object.keys(this.accountInfo)]), {
                        phoneNumber: data.phone && data.phone.phoneNumber.replace(/^\+?380/, '')
                    }
                )

                this.role = Object.assign({}, this.role, {
                    ...data.role
                })

                this.$nextTick(() => {
                    this.canSaveChanges = false
                })
            })
        },

        onRoleChange(data) {
            this.role = data
        },

        async saveChanges() {
            if (this.$v.accountInfo.$invalid) {
                this.$v.accountInfo.$touch()
            } else {
                await this.$store.dispatch('customers/updateCustomer', this.accountInfo)

                this.$nextTick(() => {
                    this.canSaveChanges = false
                    this.$v.accountInfo.$reset()
                })
            }
        }
    }
}
</script>

